import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom-v5-compat';

import { MainStoreContainer, DocumentStoreContainer } from './store';
import { useFetchSharedDocument, useAutoRedirect, useTrackViewedProject } from './services';
import { SharedPage } from './SharedPage';

const Container = () => {
  // Get "shared ID" from route params
  const { shareDocumentId } = useParams();

  useFetchSharedDocument(shareDocumentId);
  useAutoRedirect();
  useTrackViewedProject();

  return (
    <>
      <Helmet>
        <title>Shared document</title>
      </Helmet>

      <SharedPage />
    </>
  );
};

const StoreWrapper = () => {
  return (
    <MainStoreContainer>
      <DocumentStoreContainer>
        <Container />
      </DocumentStoreContainer>
    </MainStoreContainer>
  );
};

export default StoreWrapper;
